import React, { useEffect, useRef, useState } from 'react';
import DebouncedInput from '../../Inputs/DebouncedInput/DebouncedInput';
import SearchMenu from './SearchMenu';

const formatOptions = (columns) => {
    return columns
        .filter(column => !column.hasOwnProperty('enableGlobalFilter') || column?.enableGlobalFilter)
       .map(column => ({
            id: column.id,
            text: typeof column.header === 'function' ? column.header().props.children : column.header,
            active: true
        }));
};

const Search = ({ columns, globalFilter, setGlobalFilter, searchType, setSearchType, columnsVisibility, setColumnsVisibility }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [options, setOptions] = useState(formatOptions(columns));
    const dropdownRef = useRef(null);
    const containerRef = useRef(null);
    const handleMenu = (e) => {
        e.stopPropagation();
        setIsMenuOpen(!isMenuOpen);
    };

    const handleSearch = (value) => {
        const activeKeys = options.filter(option => option.active).map(option => option.id);
        setGlobalFilter({ value: String(value.trim()), keys: activeKeys });
    };

    useEffect(() => {
        const activeKeys = options.filter(option => option.active && option.id !== 'all').map(option => option.id);
        setGlobalFilter({ value: globalFilter.value, keys: activeKeys });
        return () => setGlobalFilter({ value: '', keys: [] });
    }, [options]);

    useEffect(() => {
        if (dropdownRef.current) {
            if (isMenuOpen) {
                const scrollHeight = dropdownRef.current.scrollHeight;
                dropdownRef.current.style.maxHeight = `${scrollHeight}px`;
            } else {
                dropdownRef.current.style.maxHeight = '0px';
            }
        }
    }, [isMenuOpen]);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };

        if (isMenuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMenuOpen]);

    const active = options.filter(option => option.active).length;
    const placeholder = active > 0 ? active === options.length ? 'Recherche dans toutes les colonnes' : 'Recherche dans ' + active + ' colonnes' : 'Sélectionner une colonne';

    return (
        <div ref={containerRef} className='w-fit  relative flex flex-row gap-3  flex-wrap lg:flex-nowrap'>
            <label className="relative input input-sm input-bordered flex items-center gap-2 border border-block shadow w-80">
                <DebouncedInput
                    value={globalFilter.value ?? ''}
                    onChange={value => handleSearch(value)}
                    className="grow p-2 font-lg"
                    placeholder={placeholder}
                />
                <svg onClick={handleMenu} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 flex items-center cursor-pointer">
                    <path className='cursor-pointer' strokeLinecap="round" strokeLinejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
                </svg>
                <div ref={dropdownRef} className={`max-w-80  dropdown-custom ${isMenuOpen ? 'open' : ''}`}>
                    <SearchMenu options={options} updateOptions={setOptions} searchType={searchType} setSearchType={setSearchType} columnsVisibility={columnsVisibility} setColumnsVisibility={setColumnsVisibility}/>
                </div>
            </label>

        </div>
    );
};

export default Search;
